import { render, staticRenderFns } from "./BasePageTitle.vue?vue&type=template&id=bb27c21c&scoped=true"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"
import style0 from "./BasePageTitle.vue?vue&type=style&index=0&id=bb27c21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27c21c",
  null
  
)

export default component.exports